export const router = {
  currentUser: "/Permissions/CurrentUser",
  userImage: "/Colleague/UserImage",
  tenants: "/Tenants",
  adminTenant: "/Admin/Tenant",
  switchTenant: "/Tenants/SwitchTenant",
  locations: "/Admin/Locations",
  areas: "/Areas",
  location: "/Admin/MeetingRoom/Availability",
}